import url from '../../../utils/url.js'
import {MAP, TILE_LAYER} from '../../../config/map.js'
import {POLYGON} from "../../../config/polygon";
import layersMixin from '../../../mixins/layers-mixin.js'
import {map as mapEndpoints, tko} from '../../../api/api-endpoints.js'
import measureMixin from '../mixins/measure-mixin'
import {OBJECT} from "../../../utils/map/types";

export default {
  data () {
    this.searchExactEndpoint = id => mapEndpoints.searchExact(id)
    this.mapLayers = null
    this.map = null
    this.mapEndpoints = []
    this.objectDrawer = null
    return {
      suggestionMapSearch: {q: ''},
      q: '',
      layers: []
    }
  },
  mixins: [layersMixin, measureMixin],
  computed: {
    module () {
      return 'geo'
    },
    mapBorders () {
      return this.$store.getters.readUrlEndpoint(
        mapEndpoints.heatMapRegOperators(this.$route.query.zoom || MAP.zoom)
      )
    },
  },
  methods: {
    suggestionEndpoint (ctx, q) {
      return mapEndpoints.search({query: {q}})
    },
    transformSuggestions (ctx, data) {
      if(data){
        return data.map(item =>({id: item.id, name: `${item.name || ''}`, address: item.address || '', type: item.type || ''}))
      }
    },
    async selectItemOnMapSearch ($event) {
      this.suggestionMapSearch.q = $event.name
      this.$bar.start().set(12)
      try {
        let foundObject = (await this.$store.dispatch('updateUrlEndpoint', {endpoint: this.searchExactEndpoint($event.id)})).data
        let objectForMap = this.objectDrawer.createObjectForMap(foundObject)
        if (!objectForMap) {
          throw 'Объект не найден'
        }
        this.objectDrawer.bringToMarker(objectForMap, 12)
      } catch (e) {
        this.$e.errorBox(e)
      } finally {
        this.$bar.finish()
      }

    },
    getCopyWithoutObservers (data) {
      console.log('getCopyWithoutObservers')
      return JSON.parse(JSON.stringify(data))
    },
    getMapConfigData () {
      return MAP
    },
    getMapPolygon () {
      return POLYGON
    },
    drawTiles() {
      L.tileLayer(TILE_LAYER, {}).addTo(this.map)
    },
    getLayersConf() {
      return {
        gs: {
          menuClass: 'oth',
          label: 'Отходообразователи',
          endpoint: mapEndpoints.source,
          className: 'cluster-marker',
          iconType: 'wasteCreators',
          groups: {
            org: {
              menuClass: 'oth-hoz',
              iconType: 'org',
              label: 'Организация/ИП',
              restApiOrder: 2
            },
            def: {
              menuClass: 'oth-minOb',
              iconType: 'def',
              label: 'Объекты министерства обороны',
              restApiOrder: 4
            },
            med: {
              menuClass: 'oth-med',
              iconType: 'med',
              label: 'Медицинские учреждения',
              restApiOrder: 5
            },
            uk: {
              iconType: 'uk',
              menuClass: 'oth-upOrg',
              label: 'Управляющие организации',
              restApiOrder: 1
            },
            ind: {
              menuClass: 'oth-individ',
              iconType: 'ind',
              label: 'Индивидуальное домовладение',
              restApiOrder: 6
            },
            country: {
              menuClass: 'oth-garden',
              iconType: 'country',
              label: 'Садовые, дачные партнерства',
              restApiOrder: 7
            },
            gsk: {
              menuClass: 'oth-garage',
              iconType: 'gsk',
              label: 'ГСК',
              restApiOrder: 8
            },
            set: {
              menuClass: 'oth-village',
              iconType: 'set',
              label: 'Деревни, поселки, села',
              restApiOrder: 3
            }
          }
        },
        msn: {
          iconType: 'places',
          menuClass: 'places',
          label: 'Места сбора и накопления',
          endpoint: mapEndpoints.msn,
          className: 'cluster-marker msn',
          groups: {
            container: {
              menuClass: 'places-cont',
              iconType: 'container',
              label: 'Контейнерные площадки',
              restApiOrder: 1
            },
            noContainer: {
              menuClass: 'places-noCont',
              iconType: 'noContainer',
              label: 'Бесконтейнерный сбор',
              restApiOrder: 2
            },
            separate: {
              menuClass: 'places-points',
              iconType: 'separate',
              label: 'Пункты сбора вторсырья',
              restApiOrder: 3
            }
          }
        },
        dump: {
          iconType: 'svalka',
          menuClass: 'svalka',
          label: 'Несанкционированные свалки',
          endpoint: mapEndpoints.heap,
          className: 'cluster-marker heap',
          groups: {
            heap: {
              menuClass: 'svalka-thrash',
              iconType: 'thrash',
              label: 'Навалы мусора',
              restApiOrder: 1
            },
            unauth: {
              endpoint: 'object',
              menuClass: 'svalka-noThrash',
              iconType: 'noThrash',
              label: 'Несанкционированные ОРО',
              restApiOrder: 2
            }
          }
        },
        object: {
          iconType: 'garbage',
          menuClass: 'obj',
          label: 'Объекты обращения с отходами',
          endpoint: mapEndpoints.object,
          className: 'cluster-marker object',
          groups: {
            process: {
              menuClass: 'obj-obrab',
              iconType: 'process',
              label: 'Объекты обработки',
              restApiOrder: 2
            },
            util: {
              menuClass: 'obj-utiliz',
              iconType: 'util',
              label: 'Объекты утилизации',
              restApiOrder: 5
            },
            neutral: {
              menuClass: 'obj-obezvr',
              iconType: 'neutral',
              label: 'Объекты обезвреживания',
              restApiOrder: 3
            },
            storage: {
              menuClass: 'obj-chran',
              iconType: 'storage',
              label: 'Объекты хранения',
              restApiOrder: 4
            },
            burial: {
              menuClass: 'obj-zachoron',
              iconType: 'burial',
              label: 'Объекты захоронения',
              restApiOrder: 6
            }
          }
        },
        transport: {
          menuClass: 'transp',
          label: 'Транспортировщики',
          endpoint: mapEndpoints.transport,
          className: 'cluster-marker transport',
          iconType: 'transp',
          groups: {
            trans: {
              hideFromMenu: true,
              iconType: 'transport',
              label: 'Транспортировщики',
              restApiOrder: 1
            }
          }
        }
      }
    },
    destroyMap() {
      console.log('destroyed')
      this.$emitter.emit('geo.destroyMap', {})
      // this.map.remove()
      this.map = null
    },
    afterMapInit() {
      this.initObjectsLayerDrawer()
      this.objectDrawer = this.getObjectDrawer()
    },
    getParentsConf (layersArr, conf) {
      return layersMixin.methods.getParentsConf(layersArr, conf)
    },
    getLayerEndpoint (conf, type, route) {
      return layersMixin.methods.getLayerEndpoint(conf, type, route)
    },
    afterReCreateMap () {
      //this.objectsLayerDrawer.removeLayers()
      //this.mapLayers = null
    },
    getMOEndpoint () {
      return mapEndpoints.mo()
    }
  },
  // clean object cache
  beforeRouteLeave (to, from, next) {
    this.$store.commit('deleteEndpoints', {
      endpoints: [
        mapEndpoints.objectCache()
      ]
    })
    console.warn('Clean map module data cache')
    next()
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []
    let usedRoute = url.getPrevOrCurrentRoute(route)
    console.log('methods.getLayersConf', methods.getLayersConf())

    if (usedRoute.query && usedRoute.query.layers && typeof usedRoute.query.layers === 'string') {
      let conf = methods.getParentsConf(usedRoute.query.layers.split(','), methods.getLayersConf())
      for (let key in conf) {
        if (methods.getLayerEndpoint(conf, key, usedRoute)) {
          // console.log('asyncData ' + methods.getLayerEndpoint(conf, key, route))

          promises.push(store.dispatch('updateUrlEndpoint', {
            endpoint: methods.getLayerEndpoint(conf, key, usedRoute),
            cache: (60 * 15 * 1000),
            notReactive: true
          }))
        }
      }
    }
    promises.push(store.dispatch('updateUrlEndpoint', {
      endpoint: mapEndpoints.heatMapRegOperators(route.query.zoom || MAP.zoom),
      fromCache: false
    }))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
